import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription, switchMap } from 'rxjs';
import { LexbeCase } from '../../models/case.model';
import { UserConfigs } from '../../models/user-configs.model';
import { UserConfigsService } from '../../services/user-configs.service';
import { CasesService } from '../../services/cases.service';
import { HelpService } from '../../services/help.service';

@Component({
    selector: 'lex-dashboard',
    templateUrl: './dashboard.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
	public currentCase: LexbeCase = null;
	private subscription = new Subscription();

	constructor(
		private userService: UserConfigsService,
		private casesService: CasesService,
		private helpService: HelpService
	) {}

	ngOnInit(): void {
		this.subscription.add(this.userService.getUserConfigs().pipe(
			switchMap((configs: UserConfigs) => this.casesService.getCase(configs.currentCase.caseId)))
			.subscribe((myCase: LexbeCase) => this.setCurrentCase(myCase)));

		this.helpService.updateHelpLink('home-menu/dashboard');
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	private setCurrentCase(myCase: LexbeCase) {
		this.clearCaseStateFromStorage();
		this.currentCase = myCase;
		this.casesService.showCurrentCase(myCase);
	}

	private clearCaseStateFromStorage() {
		localStorage.removeItem('compareDocumentId');
	}
}
